<template>
  <div class="ding-comingSoon ding-noAccess">
    <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/qx@2x.png" alt="">
    <div class="comingSoon-hint">非常抱歉，您暂无权限查看！<br>请联系一链客服：0516-87796393</div>
    <div class="comingSoon-hint2"><span @click="toPath('/dingWorkbench')">{{"<< 返回首页"}}</span></div>
  </div>
</template>
<script>
  export default {
    props: [],
    data () {

      return {

      }
    },
    components: {

    },
    created () {

    },
    mounted () {

    },
    methods: {

      toPath(url){
        this.$router.push(url)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/noAccess.vue